export default __webpack_public_path__ + "static/media/add-black-sm.a1119414.svg";